module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "dedication"
  }, [_c('p', {
    staticClass: "hanging",
    attrs: {
      "id": "epig"
    }
  }, [_vm._v("If you are planning for the year, grow rice.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("If you are planning for the decade, grow trees.")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("If you are planning for the centuries, grow men and women."), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('em', [_vm._v("—Chinese Proverb")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ab01162","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780062046253_epub_epig_r1.vue
// module id = 66
// module chunks = 0